import React, { Component } from 'react';
import Search_IndReport from './search/search';
import $ from 'jquery';
import ReactTelInput from 'react-telephone-input';
import axios from 'axios';
import CareReportLoader from './cate-report-loader';
import { Link} from 'react-router-dom'
import './cate-reports.css';
import API_Config from '../../../API_Config';
import Pagination from "react-js-pagination";
import RequestSample from '../../../Forms/request-sample/request-sample';
import noImageAvailable from '../../../img/noImageAvailable330.png';
import {Modal, Button, Grid, Row, Label, Col } from 'react-bootstrap';
import MetaTags from 'react-meta-tags';
import SEO  from '../../../SEO/seo';
class CateReports extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            lgShow: false,
            rpt_des: [],
            slug   : '',
            sub   : '',
            Isrender : true,
            page_url:'',
            page_count:0,
            error: null,
            isLoaded:false,
            category_result: {
                total_pages:"",
                category:{
                    meta:{
                        tags:'',
                        description:'',
                        keywords:''

                    }
                },
                reports:[
                    {
                        _id:"",
                        id:"",
                        title:"",
                        slug:"",
                        published_year:"",
                        picture_url:"",
                        description:{
                            short_description:""
                        }


                    }
                ]

            },
            isLoaderCategory:false,
            isLoaderCategory_cat:false,
            isLoaderCategory_srch:false,
            IsDataAcailable:false,
            searchData:'',
            modal_data:{}
        };
        var that = this;

        this.state.slug = this.props.slug;
        this.state.sub = this.props.sub;

        this.handlePageChange = this.handlePageChange.bind(this);
        this.isBusinessEmail = this.isBusinessEmail.bind(this);
        this.isValidPhone = this.isValidPhone.bind(this);
    }

    render() {
      // console.log(this.props.location);
        let lgClose = () => this.setState({ lgShow: false }),
            count   = 0;

        const {isLoaderCategory,rpt_des,isLoaderCategory_cat,isLoaderCategory_srch,IsDataAcailable} = this.state;
        if (!isLoaderCategory && !IsDataAcailable) {
            return (

                <div class="cate_reports">

                    {/*Search Component Start*/}
                    {/*<Search_IndReport/>*/}
                    {/*Search Component End*/}
                    <CareReportLoader/>
                    <div className="row text-center">
                    <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={10}
                        totalItemsCount={450}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                    />
                    </div>
                </div>
            )
        }
        else if(isLoaderCategory_cat) {

            return (
                <div class="cate_reports">
                        {/*<MetaTags defer={false}>*/}
                        {/*<title>{this.state.category_result.category.meta.tags}</title>*/}
                        {/*<meta id="description" name="description" content={this.state.category_result.category.meta.description} />*/}
                        {/*<meta id="keywords" name="keywords" content={this.state.category_result.category.meta.keywords} />*/}
                        {/*</MetaTags>*/}
                    {/*document.title="hey man";*/}
                    {/*<Helmet title="My Title - Test!" />*/}
                    <SEO
                        schema="AboutPage"
                        title={this.state.category_result.category.meta.tags}
                        description={this.state.category_result.category.meta.description}
                        keywords={this.state.category_result.category.meta.keywords}
                        path="/"
                        contentType="product"
                    />
                    {/*Search Component Start*/}
                    {/*<Search_IndReport/>*/}

                    {/*Search Component End*/}
                    {this.state.category_result.reports.map(i => {

                            let title           = i.title.length >= 80 ? i.title.substring(0,80)+ ' ...' : i.title ,
                                title_tooltip   = i.title.length >= 80 ? i.title : '';

                            ++count;
                            if(count == 6) {
                               return (

                                   <div class="report_card" title={title_tooltip}>
                                       <article class="report_bg">
                                           <div class="clearfix">
                                               <Link to={"/industry-reports/"+i.slug}>
                                                   <img
                                                       src={i.picture_url}
                                                       data-src={i.picture_url}
                                                       alt={title} class="pull-right"
                                                       onError={(e)=>{e.target.src=noImageAvailable}}
                                                   />
                                               </Link>
                                               <span>Published: {i.published_year}</span>
                                               <Link to={"/industry-reports/"+i.slug} >
                                                   <h3>{title.substring(0,100)+"..."}</h3>
                                               </Link>

                                               <button class="dwn_btn open-AddBookDialog" id="d2" data-toggle="modal" data-target="#myModal"
                                                       onClick={() => this.showModalView(i)}>
                                                   <i class="fa fa-download"></i> Download Free Sample NOW
                                               </button>
                                               <br/>
                                           </div>
                                       </article>
                                       {/*<RequestSample show={this.state.lgShow} data={''} data_rpt={i} onHide={lgClose}/>*/}
                                   </div>
                                   )

                            } else {
                                return (

                                    <div class="report_card" title={title_tooltip}>
                                        <article class="report_bg">
                                            <div class="clearfix">
                                                <Link to={"/industry-reports/"+i.slug}>
                                                    <img
                                                        src={'https://mordorintelligence.com:81/'+i.picture_url}
                                                        data-src={'https://mordorintelligence.com:81/'+i.picture_url}
                                                        alt={title} class="pull-right"
                                                        onError={(e)=>{e.target.src=noImageAvailable}}
                                                    />
                                                </Link>
                                                <span>Published: {i.published_year}</span>
                                                <Link to={"/industry-reports/"+i.slug} >
                                                    <h3>{title.substring(0,60)+"..."}</h3>
                                                </Link>

                                                <button class="dwn_btn open-AddBookDialog" id="d2" data-toggle="modal" data-target="#myModal"
                                                         onClick={() => this.showModalView(i)}>
                                                    <i class="fa fa-download"></i> Download Free Sample NOW
                                                </button>
                                                <br/>
                                            </div>
                                        </article>



                                        {/*Modal Data Start From here*/}
                                                    <div class="modal fade" id="myModal" role="dialog">
                                            <div class="modal-dialog modal-lg">
                                                <div class="modal-content">
                                                    <div class="modal-body">
                                                        <div class="form-container">
                                                            <span class="custom-close-button_custom" data-dismiss="modal"></span>
                                                            <h3 class="text-center">PLEASE FILL THE DETAILS TO CONTINUE</h3>
                                                            <form action="">

                                                                <div class="primary-form">
                                                                    <div class="form-input flex">
                                                                        <label for="vsitor-name">Name</label>
                                                                        <div class="input-group flex">
                                                                            <input type="text" id="name1" placeholder="First Name" class="input" required />
                                                                            <input type="text" id="name2" placeholder="Last Name" class="input" required />
                                                                        </div>
                                                                    </div>
                                                                    <div class="form-input flex">
                                                                        <label for="vsitor-email">Business Email</label>
                                                                        <input type="email" id="email12" placeholder="name@company.com" onBlur={(e) => this.isBusinessEmail(e)} required />
                                                                        <div className="input-error-message"></div>
                                                                    </div>
                                                                    <div class="form-input flex">
                                                                        <label for="visitor-phone">Phone</label>
                                                                        <ReactTelInput
                                                                            defaultCountry="us"
                                                                            flagsImagePath='/img/flags.png'
                                                                            onBlur={(e) => this.isValidPhone(e)}
                                                                        />
                                                                    </div>
                                                                    <div class="form-input flex">
                                                                        <label for="vsitor-designation">Designation</label>
                                                                        <select id="designation" required>
                                                                            <option value="" selected disabled hidden>Select</option>
                                                                            <option value="Researcher">Researcher</option>
                                                                            <option value="VP">VP</option>
                                                                            <option value="CEO">CEO</option>
                                                                            <option value="Analyst">Analyst</option>
                                                                            <option value="Sales_Manager">Sales Manager</option>
                                                                            <option value="IT_professional">IT professional</option>
                                                                            <option value="Business_Head">Business Head</option>
                                                                            <option value="Student">Student</option>
                                                                            <option value="Consultant">Consultant</option>
                                                                            <option value="Managing_Director">Managing Director</option>
                                                                            <option value="Coordinator">Coordinator</option>
                                                                            <option value="Others">Others</option>
                                                                        </select>
                                                                    </div>
                                                                    <p>* All your information will be kept confidential</p>
                                                                </div>
                                                                <div class="secondary-inputs">


                                                                    <div class="qstn01_data" >
                                                                        <h5> <i class="back-btn fa fa-chevron-circle-left " aria-hidden="true"></i> I would like to discuss further steps via:</h5>

                                                                        <input type="hidden" name="q6" id="q6" value="I would like to discuss further steps via" />


                                                                        <div class="radio-buttons flex">
                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio01" class="followup_qustn_radio" name="radio" value="Email" />
                                                                                <label for="radio01"><span></span>Email</label>
                                                                            </div>

                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio02" class="followup_qustn_radio" name="radio" value="Phone" />
                                                                                <label for="radio02"><span></span>Phone</label>
                                                                            </div>

                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio03" class="followup_qustn_radio" name="radio" value="Skype / Hangouts" />
                                                                                <label for="radio03"><span></span>Skype / Hangouts</label>
                                                                            </div>
                                                                            <textarea class="form-control textArea-style" rows="5" id="specifics_for_analyst"  placeholder="Anything specific you would like to discuss with our analyst?"></textarea>

                                                                        </div>

                                                                    </div>


                                                                    <div class="qstn2_data" >
                                                                        <input type="hidden" name="qnumber" value="q6" id="qnumber" />
                                                                        <h5> I want to:</h5>
                                                                        <input type="hidden" name="q2" id="q2" value="I want to" />
                                                                        <span class="checkbox-inline">
                                                        <input type="checkbox" id="checkbox1" name="checkboxar[]" value="Talk to Analyst" />&nbsp;&nbsp;&nbsp;&nbsp;Talk to Analyst
                                                </span>
                                                                        <span class="checkbox-inline">
                                                        <input type="checkbox" id="checkbox2" name="checkboxar[]" value="Buy the report" />&nbsp;&nbsp;&nbsp;&nbsp;Buy the report
                                                </span>
                                                                        <span class="checkbox-inline">
                                                        <input type="checkbox" id="checkbox3" name="checkboxar[]" value="Just browse" />&nbsp;&nbsp;&nbsp;&nbsp;Just browse
                                                </span>
                                                                    </div>


                                                                    <div class="qstn3_data">
                                                                        <h5>
                                                                            <i class="back-btn fa fa-chevron-circle-left " aria-hidden="true"></i> I need the complete report in:</h5>
                                                                        <input type="hidden" name="q3" id="q3" value="I need the complete report in" />



                                                                        <div class="radio-buttons flex">
                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio1" class="followup_qustn_radio" name="radioboxar" value="Less than 48 hours" />
                                                                                <label for="radio1"><span></span>Less than 48 hours</label>
                                                                            </div>

                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio2" class="followup_qustn_radio" name="radioboxar" value="A week" />
                                                                                <label for="radio2"><span></span>A week</label>
                                                                            </div>

                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio3" class="followup_qustn_radio" name="radioboxar" value="A month" />
                                                                                <label for="radio3"><span></span>A month</label>
                                                                            </div>
                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio4" class="followup_qustn_radio" name="radioboxar" value="Future Requirement" />
                                                                                <label for="radio4"><span></span>Future Requirement</label>
                                                                            </div>

                                                                        </div>
                                                                    </div>


                                                                    <div class="qstn4_data">
                                                                        <h5>  I want to know: </h5>
                                                                        <input type="hidden" name="q4" id="q4" value="I want to know" />
                                                                        <span class="checkbox-inline">
                                              <input type="checkbox" id="checkbox1" name="checkboxar[]" value="More about the market" />&nbsp;&nbsp;&nbsp;&nbsp;More about the market
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox2" name="checkboxar[]" value="Your Data Sources &amp; Engineering" />&nbsp;&nbsp;&nbsp;&nbsp;Your Data Sources &amp; Engineering
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox3" name="checkboxar[]" value="Customer Benefits You Offer" />&nbsp;&nbsp;&nbsp;&nbsp;Customer Benefits You Offer
                                            </span>
                                                                    </div>


                                                                    <div class="qstn5_data" >
                                                                        <h5 > I am looking for:</h5>
                                                                        <input type="hidden" name="q5" id="q5" value="I am looking for" />
                                                                        <span class="radio-inline" >
                                          <input type="radio" id="radio1" name="radioboxar" value="Customised report" />&nbsp;&nbsp;&nbsp;&nbsp;Customised report
                                        </span> <span class="radio-inline" >
                                          <input type="radio" id="radio2" name="radioboxar" value="Off-the-shelf report" />&nbsp;&nbsp;&nbsp;&nbsp;Off-the-shelf report
                                        </span> <span class="radio-inline" >
                                          <input type="radio" id="radio3" name="radioboxar" value="Free sample" />&nbsp;&nbsp;&nbsp;&nbsp;Free sample
                                        </span>

                                                                        <div class="radio-buttons flex">
                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio1" class="followup_qustn_radio" name="radioboxar" value="Customised report" />
                                                                                <label for="radio1"><span></span>Customised report</label>
                                                                            </div>

                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio2" class="followup_qustn_radio" name="radioboxar" value="Off-the-shelf report" />
                                                                                <label for="radio2"><span></span>Off-the-shelf report</label>
                                                                            </div>

                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio3" class="followup_qustn_radio" name="radioboxar" value="Free sample" />
                                                                                <label for="radio3"><span></span>Free sample</label>
                                                                            </div>


                                                                        </div>
                                                                    </div>


                                                                    <div class="qstn6_data">
                                                                        <h5>I would like to:</h5>
                                                                        <input type="hidden" name="q6" id="q6" value="I would like to discuss further steps via" />


                                                                        <div class="radio-buttons flex">
                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio011" class="followup_qustn_radio" name="radioboxar" value="Procure the full report"/>
                                                                                <label for="radio011"><span></span>Procure the full report</label>
                                                                            </div>

                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio021" class="followup_qustn_radio" name="radioboxar" value="Customize the report" />
                                                                                <label for="radio021"><span></span>Customize the report</label>
                                                                            </div>

                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio031" class="followup_qustn_radio" name="radioboxar" value="Speak with the analyst" />
                                                                                <label for="radio031"><span></span>Speak with the analyst</label>
                                                                            </div>
                                                                            <div class="radio-button">
                                                                                <input type="radio" id="radio041" class="followup_qustn_radio" name="radioboxar" value="Get an overview of the market" />
                                                                                <label for="radio041"><span></span>Get an overview of the market</label>
                                                                            </div>

                                                                        </div>
                                                                    </div>


                                                                    <div class="qstn7_data">
                                                                        <h5 class="iamusing" > I am using the sample document to: </h5>
                                                                        <input type="hidden" name="q7" id="q7" value="I am using the sample document to" />
                                                                        <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox1" name="checkboxar[]" value="Evaluate available options" />&nbsp;&nbsp;&nbsp;&nbsp;Evaluate available options
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox2" name="checkboxar[]" value="Ratify my purchase decision" />&nbsp;&nbsp;&nbsp;&nbsp;Ratify my purchase decision
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox3" name="checkboxar[]" value="Better understand the market" />&nbsp;&nbsp;&nbsp;&nbsp;Better understand the market
                                            </span>
                                                                    </div>
                                                                    <div class="qstn8_data">
                                                                        <h5 class="iamusing" >
                                                                            <i class="back-btn fa fa-chevron-circle-left " aria-hidden="true"></i> What would you like to add to the report?</h5>
                                                                        <small >All full report purchase come with up to 10% free additional customization.</small>
                                                                        <input type="hidden" name="q8" id="q8" value="I have custom requirements" />
                                                                        <textarea class="form-control textArea-style" rows="5" id="custom_requirements"></textarea>
                                                                    </div>


                                                                </div>
                                                                <div class="btn-submit text-center">
                                                                    <button type="button" id="new_button11">SUBMIT</button>
                                                                </div>
                                                            </form>
                                                        </div>

                                                    </div>
                                                    {/*<div class="modal-footer">*/}
                                                        {/*<button type="button" onClick={this.props.onHide} class="btn btn-default" data-dismiss="modal">Close</button>*/}
                                                        {/*<input type="button" id="new_button1" className="btn btn-success" value="SUBMIT" />*/}
                                                    {/*</div>*/}
                                                </div>
                                            </div>
                                        </div>
                                                    <div class="modal fade in newsModal" id="newsModal" role="dialog" >
                                                                <div class="modal-dialog">
                                                                    <div class="modal-content">
                                                                        <div class="modal-header">
                                                                            <button type="button" class="close" data-dismiss="modal">×</button>
                                                                            <h4 class="modal-title">{this.state.modal_data.title}</h4>
                                                                        </div>
                                                                        <div class="modal-body">
                                                                            <div class="modal-body-inner"></div>
                                                                            <p id="txts">Thank you for your interest in our report. Our intelligence experts will be reaching out to you with the sample document/next steps shortly.</p>
                                                                        </div>
                                                                        <div class="modal-footer">
                                                                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                    </div>
                                        {/*Modal Data End From here*/}

                                    </div>
                                )
                            }




                    })}

                    <div className="report_card_pag text-center">
                            <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={10}
                                totalItemsCount={this.state.page_count}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                            />
                    </div>

                </div>
            );
        }
        else if(isLoaderCategory_srch) {
            return (
                <div >
                    <div className="cate_reports_search">
                        Showing results for ' {this.state.searchData} '... Can't find what you need? Reach us out <Link to={'contact-us'}>here</Link>
                    </div>
                <div class="cate_reports">


                    {/*<MetaTags>*/}
                        {/*<title>Search</title>*/}
                        {/*<meta id="description" name="description" content="Search data" />*/}
                        {/*<meta id="keywords" name="keywords" content="Search Description" />*/}
                    {/*</MetaTags>*/}



                    {/*Search Component Start*/}
                    {/*<Search_IndReport/>*/}

                    {/*Search Component End*/}
                    {this.state.category_result.map(i => {

                        let title           = i.title.length >= 80 ? i.title.substring(0,80)+ ' ...' : i.title ,
                            title_tooltip   = i.title.length >= 80 ? i.title : '';

                        ++count;
                        if(count == 6) {
                            return (

                                <div class="report_card" title={title_tooltip}>
                                    <article class="report_bg">
                                        <div class="clearfix">
                                            <Link to={"/industry-reports/"+i.slug}>
                                                <img
                                                    src={i.picture_url}
                                                    data-src={i.picture_url}
                                                    alt={title} class="pull-right"
                                                    onError={(e)=>{e.target.src=noImageAvailable}}
                                                />
                                            </Link>
                                            <span>Published: {i.published_year}</span>
                                            <Link to={"/industry-reports/"+i.slug} >
                                                <h3>{title}</h3>
                                            </Link>

                                            <button class="dwn_btn open-AddBookDialog" id="d2" data-toggle="modal" data-target="#myModal"
                                                    onClick={() => this.showModalView(i)}>
                                                <i class="fa fa-download"></i> Download Free Sample NOW
                                            </button>
                                            <br/>
                                        </div>
                                    </article>
                                    {/*<RequestSample show={this.state.lgShow} data={''} data_rpt={i} onHide={lgClose}/>*/}
                                </div>
                            )

                        } else {
                            return (

                                <div class="report_card" title={title_tooltip}>
                                    <article class="report_bg">
                                        <div class="clearfix">
                                            <Link to={"/industry-reports/"+i.slug}>
                                                <img
                                                    src={i.picture_url}
                                                    data-src={i.picture_url}
                                                    alt={title} class="pull-right"
                                                    onError={(e)=>{e.target.src=noImageAvailable}}
                                                />
                                            </Link>
                                            <span>Published: {i.published_year}</span>
                                            <Link to={"/industry-reports/"+i.slug} >
                                                <h3>{title}</h3>
                                            </Link>

                                            <button class="dwn_btn open-AddBookDialog" id="d2" data-toggle="modal" data-target="#myModal"
                                                    onClick={() => this.showModalView(i)}>
                                                <i class="fa fa-download"></i> Download Free Sample NOW
                                            </button>
                                            <br/>
                                        </div>
                                    </article>



                                    {/*Modal Data Start From here*/}
                                    <div class="modal fade" id="myModal" role="dialog">
                                        <div class="modal-dialog modal-lg">
                                            <div class="modal-content">
                                                <div class="modal-body">
                                                    <div class="mask">

                                                        <div class="circle"> <img src={'https://mordorintelligence.com:81'+this.state.modal_data.picture_url}  /> </div>
                                                        <div class="login">
                                                            <h4 className="title_style">{this.state.modal_data.title} <br/><br/>
                                                                <small>Test
                                                                     PLEASE FILL THE DETAILS TO CONTINUE</small>
                                                            </h4>
                                                            <hr />
                                                            <form id="login-form">

                                                                <div class="row">
                                                                    <div class="col-sm-4">
                                                                        <div class="inputBox ">
                                                                            <select class="form-control from_select_style" id="salutation">
                                                                                <option value="Mr">Mr</option>
                                                                                <option value="Ms">Ms</option>
                                                                                <option value="Mrs">Mrs</option>
                                                                                <option value="Dr">Dr</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-sm-4">
                                                                        <div class="inputBox ">
                                                                            <div class="inputText">First Name</div>
                                                                            <input type="text" name="" class="input" id="name1" />
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-sm-4">
                                                                        <div class="inputBox">
                                                                            <div class="inputText">Last Name</div>
                                                                            <input type="text" name="" class="input" id="name2" />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="row">

                                                                    <div class="col-sm-6">
                                                                        <div class="inputBox ">
                                                                            <div class="inputText">Country Code</div>
                                                                            <input class="input" type="tel" onKeyPress="return isNumber(event)" name="country_code" id="country_code" required=""  maxLength="7" data-format="+ ddddd" />
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-sm-6">
                                                                        <div class="inputBox">
                                                                            <div class="inputText">Phone Number</div>
                                                                            <input class="input" type="tel" onKeyPress="return isNumber2(event)" name="phone1" id="phone1" required="" maxLength="23" data-format="ddddd ddddd ddddd ddddd"  />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="row">

                                                                    <div class="col-sm-12">
                                                                        <div class="inputBox ">
                                                                            <div class="inputText">Business Email</div>
                                                                            <input class="input" type="email"  name="email" id="email1" required=""  />
                                                                        </div>
                                                                    </div>


                                                                </div>


                                                                {/*Hidden at first*/}
                                                                <div class="qstn01_data" >
                                                                    <h5> <i class="back-btn fa fa-chevron-circle-left " aria-hidden="true"></i> I would like to discuss further steps via:</h5>
                                                                    <input type="hidden" name="q6" id="q6" value="I would like to discuss further steps via" /> <span class="radio-inline">
                                      <input type="radio" id="radio1" class="followup_qustn_radio" name="radioboxar" value="Email"  />&nbsp;&nbsp;&nbsp;&nbsp;Email
                                      </span> <span class="radio-inline" >
                                        <input type="radio" id="radio2" class="followup_qustn_radio" name="radioboxar" value="Phone"  />&nbsp;&nbsp;&nbsp;&nbsp;Phone
                                      </span> <span class="radio-inline">
                                        <input type="radio" id="radio3" class="followup_qustn_radio" name="radioboxar" value="Skype / Hangouts"  />&nbsp;&nbsp;&nbsp;&nbsp;Skype / Hangouts
                                      </span>
                                                                    <textarea class="form-control textArea-style" rows="5" id="specifics_for_analyst"  placeholder="Anything specific you would like to discuss with our analyst?"></textarea>
                                                                </div>

                                                                {/*Second Hidden Div*/}
                                                                <div class="qstn2_data" >
                                                                    <input type="hidden" name="qnumber" value="q6" id="qnumber" />
                                                                    <h5> I want to:</h5>
                                                                    <input type="hidden" name="q2" id="q2" value="I want to" />
                                                                    <span class="checkbox-inline">
                                                        <input type="checkbox" id="checkbox1" name="checkboxar[]" value="Talk to Analyst" />&nbsp;&nbsp;&nbsp;&nbsp;Talk to Analyst
                                                </span>
                                                                    <span class="checkbox-inline">
                                                        <input type="checkbox" id="checkbox2" name="checkboxar[]" value="Buy the report" />&nbsp;&nbsp;&nbsp;&nbsp;Buy the report
                                                </span>
                                                                    <span class="checkbox-inline">
                                                        <input type="checkbox" id="checkbox3" name="checkboxar[]" value="Just browse" />&nbsp;&nbsp;&nbsp;&nbsp;Just browse
                                                </span>
                                                                </div>

                                                                {/*Third Block Div*/}
                                                                <div class="qstn3_data">
                                                                    <h5>
                                                                        <i class="back-btn fa fa-chevron-circle-left " aria-hidden="true"></i> I need the complete report in:</h5>
                                                                    <input type="hidden" name="q3" id="q3" value="I need the complete report in" />
                                                                    <span class="radio-inline">
                                          <input type="radio" id="radio1" class="followup_qustn_radio" name="radioboxar" value="Less than 48 hours"  />&nbsp;&nbsp;&nbsp;&nbsp;48 hours
                                        </span> <span class="radio-inline">
                                          <input type="radio" id="radio2" class="followup_qustn_radio" name="radioboxar" value="A week"  />&nbsp;&nbsp;&nbsp;&nbsp;1 Week
                                        </span> <span class="radio-inline" >
                                          <input type="radio" id="radio3" class="followup_qustn_radio" name="radioboxar" value="A month"  />&nbsp;&nbsp;&nbsp;&nbsp;1 Month
                                        </span> <span class="radio-inline" >
                                          <input type="radio" id="radio4" class="followup_qustn_radio" name="radioboxar" value="Future Requirement"  />&nbsp;&nbsp;&nbsp;&nbsp;In the future.
                                        </span>
                                                                </div>

                                                                {/*Fourth Hidden Div*/}
                                                                <div class="qstn4_data">
                                                                    <h5>  I want to know: </h5>
                                                                    <input type="hidden" name="q4" id="q4" value="I want to know" />
                                                                    <span class="checkbox-inline">
                                              <input type="checkbox" id="checkbox1" name="checkboxar[]" value="More about the market" />&nbsp;&nbsp;&nbsp;&nbsp;More about the market
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox2" name="checkboxar[]" value="Your Data Sources &amp; Engineering" />&nbsp;&nbsp;&nbsp;&nbsp;Your Data Sources &amp; Engineering
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox3" name="checkboxar[]" value="Customer Benefits You Offer" />&nbsp;&nbsp;&nbsp;&nbsp;Customer Benefits You Offer
                                            </span>
                                                                </div>

                                                                {/*Fifth Hidden Div*/}
                                                                <div class="qstn5_data" >
                                                                    <h5 > I am looking for:</h5>
                                                                    <input type="hidden" name="q5" id="q5" value="I am looking for" />
                                                                    <span class="radio-inline" >
                                          <input type="radio" id="radio1" name="radioboxar" value="Customised report" />&nbsp;&nbsp;&nbsp;&nbsp;Customised report
                                        </span> <span class="radio-inline" >
                                          <input type="radio" id="radio2" name="radioboxar" value="Off-the-shelf report" />&nbsp;&nbsp;&nbsp;&nbsp;Off-the-shelf report
                                        </span> <span class="radio-inline" >
                                          <input type="radio" id="radio3" name="radioboxar" value="Free sample" />&nbsp;&nbsp;&nbsp;&nbsp;Free sample
                                        </span>
                                                                </div>

                                                                {/*Sixth Hidden Div*/}
                                                                <div class="qstn6_data">
                                                                    <h5>I would like to:</h5>
                                                                    <input type="hidden" name="q6" id="q6" value="I would like to discuss further steps via" />
                                                                         <span class="radio-inline">
                                                                            <input type="radio" id="radio011" name="radioboxar" value="Procure the full report " />&nbsp;&nbsp;&nbsp;&nbsp;Procure the full report
                                                                         </span>
                                                                                                <span class="radio-inline" >
                                                                            <input type="radio" id="radio021" name="radioboxar" value="Customize the report" />&nbsp;&nbsp;&nbsp;&nbsp;Customize the report
                                                                         </span>
                                                                                                <span class="radio-inline">
                                                                            <input type="radio" id="radio031" name="radioboxar" value="Speak with the analyst" />&nbsp;&nbsp;&nbsp;&nbsp;Speak with the analyst
                                                                         </span>
                                                                                                <span class="radio-inline" >
                                                                            <input type="radio" id="radio041" name="radioboxar" value="Get an overview of the market" />&nbsp;&nbsp;&nbsp;&nbsp;Get an overview of the market
                                                                         </span>
                                                                </div>

                                                                {/*Seventh Hidden Div*/}
                                                                <div class="qstn7_data">
                                                                    <h5 class="iamusing" > I am using the sample document to: </h5>
                                                                    <input type="hidden" name="q7" id="q7" value="I am using the sample document to" />
                                                                    <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox1" name="checkboxar[]" value="Evaluate available options" />&nbsp;&nbsp;&nbsp;&nbsp;Evaluate available options
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox2" name="checkboxar[]" value="Ratify my purchase decision" />&nbsp;&nbsp;&nbsp;&nbsp;Ratify my purchase decision
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox3" name="checkboxar[]" value="Better understand the market" />&nbsp;&nbsp;&nbsp;&nbsp;Better understand the market
                                            </span>
                                                                </div>

                                                                {/*Eighth Hidden Div*/}
                                                                <div class="qstn8_data">
                                                                    <h5 class="iamusing" >
                                                                        <i class="back-btn fa fa-chevron-circle-left " aria-hidden="true"></i> What would you like to add to the report?</h5>
                                                                    <small >All full report purchase come with up to 10% free additional customization.</small>
                                                                    <input type="hidden" name="q8" id="q8" value="I have custom requirements" />
                                                                    <textarea class="form-control textArea-style" rows="5" id="custom_requirements"></textarea>
                                                                </div>


                                                            </form>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button type="button" onClick={this.props.onHide} class="btn btn-default" data-dismiss="modal">Close</button>
                                                    <input type="button" id="new_button11" className="btn btn-success" value="SUBMIT" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*Modal Data End From here*/}

                                </div>
                            )
                        }




                    })}

                    <div className="report_card_pag text-center">
                        <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.page_count}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                        />
                    </div>
                </div>
                </div>
                )


        }
        else if(IsDataAcailable) {
            return(
            <div className="cate_reports_search">
                Showing results for ' {this.state.searchData} '... Can't find what you need? Reach us out <Link to={'contact-us'}>here</Link>
            </div>
            )
        }
    }

    showModalView(data) {
        console.log('data',data)

        localStorage.setItem("reportdata",JSON.stringify(data))

        $("#model_report_id").val(data.id);
        $("#model_report_name").val(data.title);
        $("#slug").val(data.slug);
        this.setState(
            {
                modal_data:data
            }
        )
    }
    isBusinessEmail(e) {
        console.log(e.target.value);
        var email = e.target.value;
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        console.log(re.test(email));
        var isValidEmail = re.test(email);

        if(isValidEmail) {
            if( email.split("@")[1].split(".")[0] === "gmail" || email.split("@")[1].split(".")[0] === "yahoo" ||
                email.split("@")[1].split(".")[1] === "edu"   || email.split("@")[1].split(".")[1] === "student" ||
                email.split("@")[1] === "163.com" || email.split("@")[1].split(".")[0] === "naver"){
                console.log('InValid');
                document.querySelector('.input-error-message').style.display = 'block';
                document.querySelector('.input-error-message').innerHTML = 'Please enter a valid Business Email!';
                // document.getElementById('new_button1').style.color = 'grey';
                document.getElementById('new_button11').style.opacity = '0.4';
                document.getElementById('new_button11').disabled = true;
                return true;

            }
            else{
                document.querySelector('.input-error-message').style.display = 'none';
                console.log('Valid');
                document.getElementById('new_button11').disabled = false;
                document.getElementById('new_button11').style.opacity = '1';
                return false;
            }
        }
        else if (email === '') {
            document.querySelector('.input-error-message').style.display = 'none';
            // document.getElementById('new_button1').style.color = 'grey';
            document.getElementById('new_button11').style.opacity = '0.4';
            document.getElementById('new_button11').disabled = true;
        }
        else {
            document.querySelector('.input-error-message').style.display = 'block';
            document.querySelector('.input-error-message').innerHTML = "Please enter a valid Email!";
            // document.getElementById('new_button1').style.color = 'grey';
            document.getElementById('new_button11').style.opacity = '0.4';
            document.getElementById('new_button11').disabled = true;
        }
    }

    isValidPhone(e) {
        console.log(e);
        if(e == '+' || e == '') {
            document.getElementById('new_button11').disabled = true;
            document.getElementById('new_button11').style.opacity = '0.4';
        }
        else {
            document.getElementById('new_button11').disabled = false;
            document.getElementById('new_button11').style.opacity = '1';
        }
    }


    isNumber(evt) {
        var iKeyCode = (evt.which) ? evt.which : evt.keyCode
        if (iKeyCode != 46 && iKeyCode != 43 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
        {
            $(".newmodal_error").text("Please enter valid country code");
            $("#country_code").focus();
            return false;
        }
        return true;
    }
    isNumber2(evt) {
        var iKeyCode = (evt.which) ? evt.which : evt.keyCode
        if (iKeyCode != 46 && iKeyCode != 43 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
        {
            $(".newmodal_error").text("Please enter valid mobile number");
            $("#phone1").focus();
            return false;
        }
        return true;
    }

    componentDidMount() {
        setTimeout(() => {
            this.GetContentData();
            this.GetContentData_ReportData(this.state.slug,this.state.sub);
        }, 200);




        $('body').on('focus','.input', function () {
            $(this).parent().addClass("focus");
        })



        $(function(e){

// =============================== AUTHOR : DEVAKS =============================== //

            window.main_question     = null;
            window.followup_question = null;
            window.followup_answer   = null;
            window.main_question_id  = null;

            $(".qstn01_data").hide();
            $(".qstn8_data").hide();

            $('body').on('change','input:radio', function (event) {


                if ( event.target.id == "radio011"  ) {

                    window.main_question    = $("#radio011").val();
                    window.main_question_id = "radio011";
                    $(".qstn6_data").hide();
                    $(".qstn3_data").show();
                    // $(".qstn6_data").hide('slide', {direction: 'left'},  300);
                    // setTimeout(function(){
                    //     $(".qstn3_data").show('slide', {direction: 'right'}, 350);
                    // },300)

                } else if ( event.target.id == "radio021" ) {

                    window.main_question    = $("#radio021").val().trim();
                    window.main_question_id = "radio021";
                    $(".qstn6_data").hide();
                    $(".qstn8_data").show();
                    // $(".qstn6_data").hide('slide', {direction: 'left'},  300);
                    // setTimeout(function(){
                    //     $(".qstn8_data").show('slide', {direction: 'right'}, 350);
                    // },300)

                } else if ( event.target.id == "radio031" ) {

                    window.main_question    = $("#radio031").val().trim();
                    window.main_question_id = "radio031";
                    $(".qstn6_data").hide();
                    $(".qstn01_data").show();

                    // $(".qstn6_data").hide('slide', {direction: 'left'},  300);
                    // setTimeout(function(){
                    //     $(".qstn01_data").show('slide',{direction:'right'},  350);
                    // },300)

                } else if ( event.target.id == "radio041" ) {

                    window.main_question    = "I want to know more about the market."
                    window.main_question_id = "radio041";

                }
            });

            $('body').on('change','.followup_qustn_radio', function (event) {
                if ( window.main_question_id == "radio02" ) {

                    window.followup_question  = $(this).parent().parent().parent().find("h5").text().trim();
                    window.followup_answer    = $.trim( $("#custom_requirements").val() );

                } else if ( window.main_question_id != "radio04" ) {

                    window.followup_question  = $(this).parent().parent().parent().find("h5").text().trim();
                    window.followup_answer    = $.trim( $(this).val());

                } else {

                    window.followup_question  = null;
                    window.followup_answer    = null;

                }
            })

            $('body').on('click','.back-btn', function () {
                $(".qstn3_data").hide();
                $(".qstn8_data").hide();
                $(".qstn01_data").hide();
                $(".qstn6_data").show();
            })


// =============================== ENDS =============================== //



            $('.search-panel .dropdown-menu').find('a').click(function(e) {

                e.preventDefault();
                var param = $(this).attr("href").replace("#","");
                var concept = $(this).text();
                $('.search-panel span#search_concept').text(concept);
                $('.input-group #search_param').val(param);
                $('.input-group #search_parama').val(param);
            });
            $('.search-panelll .dropdown-menu').find('a').click(function(e) {

                e.preventDefault();
                var param = $(this).attr("href").replace("#","");
                var concept = $(this).text();
                $('.search-panelll span#search_concept1').text(concept);
                $('#search_param1').val(param);
            });
            $('.search-panell .dropdown-menu').find('a').click(function(e) {

                e.preventDefault();
                var param = $(this).attr("href").replace("#","");
                var concept = $(this).text();
                $('.search-panell span#search_concept').text(concept);
                $('.input-group #search_param').val(param);
            });


            /* show cart number */

            var cReports = JSON.parse(localStorage.getItem('cReports'));
            if (typeof cReports == 'undefined' || cReports == null)
            {
                cReports = [ ];
            }

            $('#cart_no').text(cReports.length);

            /* show cart number */

        });
    }

    componentWillReceiveProps(nextProps) {
      console.log(nextProps);
      
      if(nextProps.location.pathname.split("/").length === 4) {
        var new_param = nextProps.location.pathname.split("/").pop();
        console.log(new_param);
        this.GetContentData_ReportData(new_param, '');
      }
      else if (nextProps.location.pathname.split("/").length === 5) {
        var new_subparam = nextProps.location.pathname.split("/").pop();
        var new_categoryparam =  nextProps.location.pathname.split("/").slice(3,4)[0];
        this.GetContentData_ReportData(new_categoryparam, new_subparam);
      }
    }




    GetContentData() {

        let url = API_Config.http_url +'/categories';
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {
                    // setTimeout( function() {
                    this.setState({
                        isLoaded: true,
                        rpt_des: result
                    });
                    // },300);
                },
                (error) => {
                    // this.setState({
                    //     isLoaded: true,
                    //     error
                    // });
                }
            )

    }

    GetContentData_ReportData(param, sub_param) {

        let srch = localStorage.getItem('strSrch');

        this.setState({
            isLoaderCategory:false
        })

        try{
            if(srch != "" && srch != null) {
                let url = API_Config.http_url+'/reports/search?q='+srch+'';
                fetch(url)
                    .then(res => res.json())
                    .then(
                        (result) => {


                            if(result.data !== "No data found.") {

                                result = result.filter(function(n){ return n != undefined });
                                this.setState({
                                    isLoaderCategory: true,
                                    category_result: result,
                                    page_count:result.length,
                                    isLoaderCategory_cat:false,
                                    isLoaderCategory_srch:true,
                                    IsDataAcailable:false,
                                    searchData:srch
                                });
                            } else {
                                this.setState({
                                    isLoaderCategory: true,
                                    category_result: [],
                                    page_count:0,
                                    isLoaderCategory_cat:false,
                                    isLoaderCategory_srch:false,
                                    IsDataAcailable:true,
                                    searchData:srch
                                });
                            }
                            document.getElementById('industry_descr').innerText = "";
                            document.getElementById('industry_header').innerText = "Search Result For -" + srch;
                            localStorage.setItem("strSrch","");
                        },
                        (error) => {
                            document.getElementById('industry_descr').innerText = "";
                            document.getElementById('industry_header').innerText = "Search Result For -" + srch;
                            localStorage.setItem("strSrch","");
                            this.setState({
                                IsDataAcailable:true
                            })
                        }
                    )
            }
            else {
                let slug = param,
                url = API_Config.http_url +API_Config.end_point.reports
                if(slug == undefined) {
                    slug = "agriculture";

                }
                if(sub_param == undefined){
                    url =url+ slug;
                } else {
                    url =url+  slug + "/"+ sub_param;
                }

                this.setState({
                    page_url:url
                })
                fetch(url)
                    .then(res => res.json())
                    .then(
                        (result) => {

                            if(window.location.pathname != "/industry-reports") {
                                document.getElementById('industry_descr').innerText = result.category.description.short_description.substring(0,150);
                                document.getElementById('industry_header').innerText = result.category.title;
                            } else {
                                document.getElementById('industry_descr').innerText = "Our industry reports offer insights on major trends, technologies, competition and opportunities in your area of interest. Your varied needs are our points of focus!";
                                document.getElementById('industry_header').innerText = "Industry Reports";
                            }
                            this.setState({
                                isLoaderCategory: true,
                                category_result: result,
                                page_count:result.total_pages,
                                isLoaderCategory_srch:false,
                                isLoaderCategory_cat:true

                            });
                        },
                        (error) => {
                            this.setState({
                                isLoaderCategory: false,
                                IsDataAcailable:true
                            })
                        }
                    )

            }
        }
        catch(e) {
            alert("here")
            localStorage.setItem("strSrch","");
            this.setState({
                isLoaderCategory: false,
                IsDataAcailable:true
            })
        }
    }

    handlePageChange(pageNumber) {

        this.setState({activePage: pageNumber});
        this.callWhenPagignation(pageNumber);

    }
    callWhenPagignation(pageNumber) {


        var body = $("html, body");
        body.stop().animate({scrollTop:500}, 500, 'swing', function() {
        });

        this.setState({
            isLoaderCategory: false,
        })
        let  url = this.state.page_url+"?page="+pageNumber;

        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {

                    this.setState({
                        isLoaderCategory: true,
                        category_result: result,
                        page_count:result.total_pages
                    });
                },
                (error) => {

                }
            )
    }
}


export default CateReports;


// WEBPACK FOOTER //
// ./src/industry-reports/content/cate-reports/cate-reports.js